/**
 * @packageDocumentation
 * @module f1/fn
 */

export interface Noop {
  /**
   * Same as `function(){}`.
   *
   * @public
   * @function f1.noop
   * @example
   *
   * ```ts
   * f1.noop() => undefined
   * ```
   */
  (): void;
}

/**
 * @see Noop
 */
export default () => {};
